
import React, {Component, PropTypes} from 'react'
import style from './ToggleablePanel.less'
import cx from 'classnames'

class ToggleablePanel extends Component {
    state = {}
    togglePanel = () => {
        if (this.hasMoreChildren()) {
            this.setState({toggle: !this.state.toggle})
        }
    }

    hasMoreChildren = () => {
        const {children} = this.props
        return children.slice(1).filter(Boolean).reduce((a, b) => a.concat(b), []).length > 0
    }

    componentDidMount() {
        const {startHidden} = this.props
        this.setState({toggle: !startHidden})
    }

    render() {
        const {children} = this.props
        const {toggle} = this.state

        return <div className={cx({[style.toggleablePanel]: true, [style.expanded]: toggle, [style.expandable]: this.hasMoreChildren()})}>
            <div onClick={this.togglePanel} className={style.header}><span className={style.arrow}>> </span>{children[0]}</div>
            {toggle && (<div>{children.slice(1)}</div>)}
        </div>
    }
}
export default ToggleablePanel


// WEBPACK FOOTER //
// ./lib/core/components/ToggleablePanel.js